import { useAtom, useAtomValue, useSetAtom } from 'jotai'
import { atomWithStorage } from 'jotai/utils'

type OpportunitiesV3Filters = {
  priority: number[]
  offer: string[]
  public_rating: string[]
  fidelity: string[]
  segment: string[]
  network: string[]
  subsidiary: string[]
  user_std_code: string[]
  order_by?: string
  order_by_direction?: string
}

const defaultFilters: OpportunitiesV3Filters = {
  priority: [],
  offer: [],
  public_rating: [],
  fidelity: [],
  segment: [],
  network: [],
  subsidiary: [],
  user_std_code: [],
  order_by: undefined,
  order_by_direction: undefined
}

const sessionStorageAdapter = {
  getItem: (key: string, initialValue?: OpportunitiesV3Filters) => {
    if (typeof window === 'undefined') return initialValue ?? defaultFilters

    const raw = window.sessionStorage.getItem(key)

    if (!raw) return initialValue ?? defaultFilters

    try {
      return JSON.parse(raw) as OpportunitiesV3Filters
    } catch {
      return initialValue ?? defaultFilters
    }
  },
  setItem: (key: string, value: OpportunitiesV3Filters) => {
    if (typeof window === 'undefined') return

    window.sessionStorage.setItem(key, JSON.stringify(value))
  },
  removeItem: (key: string) => {
    if (typeof window === 'undefined') return

    window.sessionStorage.removeItem(key)
  }
}

const opportunitiesV3FiltersAtom = atomWithStorage<OpportunitiesV3Filters>(
  'opportunities-v3-filters',
  defaultFilters,
  sessionStorageAdapter
)

export const useOpportunitiesV3FiltersAtom = () => useAtom(opportunitiesV3FiltersAtom)

export const useOpportunitiesV3FiltersValue = () => useAtomValue(opportunitiesV3FiltersAtom)

export const useSetOpportunitiesV3Filters = () => useSetAtom(opportunitiesV3FiltersAtom)

export { defaultFilters }
